<div class="ts-box" [class.ts-collapsed]="!isExpanded">
	<button *ngIf="!isExpanded" type="button" class="ts-toggle" title="Change theme" (click)="toggleExpanded()">
		<i class="fas fa-palette"></i>
	</button>

	<ng-container *ngIf="isExpanded">
		<div class="ts-header">
			<span><i class="fas fa-palette me-1"></i>Theme</span>
			<i *ngIf="isSaving" class="far fa-spinner fa-spin ms-2"></i>
			<button type="button" class="btn btn-link btn-sm p-0 ms-auto" title="Minimize" (click)="toggleExpanded()">
				<i class="far fa-minus"></i>
			</button>
		</div>

		<div class="d-flex align-items-center gap-1">
			<button type="button" class="btn btn-outline-secondary btn-sm" title="Previous theme" (click)="step(-1)">
				<i class="far fa-chevron-left"></i>
			</button>
			<select class="form-select form-select-sm" [ngModel]="theme" (ngModelChange)="setTheme($event)">
				<option *ngFor="let t of themes" [value]="t.id">{{ t.text }}</option>
			</select>
			<button type="button" class="btn btn-outline-secondary btn-sm" title="Next theme" (click)="step(1)">
				<i class="far fa-chevron-right"></i>
			</button>
		</div>

		<div class="form-check mt-2 mb-0">
			<input class="form-check-input" type="checkbox" id="themeSwitcherDarkOnly" [(ngModel)]="darkOnly" (ngModelChange)="onDarkOnlyChanged()" />
			<label class="form-check-label" for="themeSwitcherDarkOnly">Dark themes only</label>
		</div>
	</ng-container>
</div>
